import React from "react";
import { Checkbox as MuiCheckbox } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTheme as useCustomTheme } from "../theme/useTheme";
import { useScopedDisabled } from "../hooks/useClientReadOnly";

export const Checkbox = ({
  id,
  checked,
  onCheckedChange,
  disabled: disabledProp,
  sx = {},
  ...props
}) => {
  const disabled = useScopedDisabled(disabledProp);
  const theme = useTheme();
  const { colors } = useCustomTheme();

  const handleChange = (event) => {
    if (onCheckedChange) {
      onCheckedChange(event.target.checked);
    }
  };

  return (
    <MuiCheckbox
      id={id}
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      sx={{
        padding: "4px",
        color: theme.palette.text.secondary,
        "&.Mui-checked": {
          color: colors.primary.main,
        },
        "&:hover": {
          backgroundColor: `${colors.primary.main}08`,
        },
        "& .MuiSvgIcon-root": {
          fontSize: "1.25rem",
        },
        ...sx,
      }}
      {...props}
    />
  );
};
